<template>
    <v-card v-bind="$attrs" class="account-address-card" outlined :disabled="false">
        <div class="account-address-card__header">
            <span class="account-address-card__mark" aria-hidden="true">
                <v-icon>{{ mdiMapMarker }}</v-icon>
            </span>
            <div class="account-address-card__heading">
                <span class="account-address-card__eyebrow">ACCOUNT ADDRESS</span>
                <h3>{{ label }}</h3>
            </div>
            <v-btn class="account-address-card__edit" icon :aria-label="`Edit ${label.toLowerCase()} address`" @click="emitEdit">
                <v-icon>{{ mdiPencil }}</v-icon>
            </v-btn>
        </div>

        <div v-if="addressLines.length" class="account-address-card__lines">
            <span v-for="(line, index) in addressLines" :key="index">{{ line }}</span>
        </div>
        <div v-else class="account-address-card__empty">
            No {{ label.toLowerCase() }} address saved yet. Add one to make checkout and returns easier.
        </div>
    </v-card>
</template>

<script>
import Vue from 'vue'
import { mdiMapMarker, mdiPencil } from '@mdi/js'
export default Vue.extend({
    name: `AccountViewAddressMinimized`,
    props: {
        address: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            default: () => `Address`
        }
    },
    data: () => ({
        mdiMapMarker,
        mdiPencil
    }),
    computed: {
        addressLines() {
            const {
                firstName = '', lastName = '', company = '', line1 = '', line2 = '',
                city = '', state = '', postalCode = '', country = ''
            } = this.address || {}
            return [
                [firstName, lastName].filter(Boolean).join(' '),
                company,
                line1,
                line2,
                [city, state, postalCode].filter(Boolean).join(' '),
                country
            ].filter(Boolean)
        },
        validLocation() {
            // Must at least be on Earth
            return this.address.country
        },
        uiAddress() {
            const {
                firstName = ``,
                lastName = ``,
                company = ``,
                line1 = ``,
                line2 = ``,
                city = ``,
                state = ``,
                postalCode = ``,
                country = ``
            } = this.address

            let displayAddy = ``
            displayAddy += firstName || lastName ? `${firstName} ${lastName}\n` : ``
            displayAddy += company ? `${company}\n` : ``
            displayAddy += line1 ? `${line1}\n` : ``
            displayAddy += line2 ? `${line2}\n` : ``
            displayAddy += `${city} ${state} ${postalCode} ${country}`

            return displayAddy
        }
    },
    methods: {
        map() {
            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.uiAddress)}`)
        },
        emitEdit() {
            this.$emit(`edit`)
        }
    }
})
</script>

<style scoped>
.account-address-card {
    padding: 17px;
    border-radius: 9px;
}
.account-address-card.theme--dark {
    color: #f1f2f5;
    background: rgba(23, 25, 31, 0.38);
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: none !important;
}
.account-address-card__header {
    display: flex;
    align-items: center;
    gap: 11px;
}
.account-address-card__mark {
    display: grid;
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    color: #ff9a74;
    background: rgba(219, 81, 32, 0.12);
    border: 1px solid rgba(240, 120, 76, 0.24);
    border-radius: 10px;
    place-items: center;
}
.account-address-card__mark .v-icon {
    color: inherit;
    font-size: 19px;
}
.account-address-card__heading {
    min-width: 0;
    flex: 1;
}
.account-address-card__eyebrow {
    color: #f2a58b;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 1.2px;
}
.account-address-card__heading h3 {
    margin: 2px 0 0;
    color: inherit;
    font-size: 15px;
    font-weight: 600;
}
.account-address-card__edit.v-btn {
    color: #ff9a74;
    background: rgba(219, 81, 32, 0.09);
    border: 1px solid rgba(240, 120, 76, 0.23);
}
.account-address-card__edit.v-btn:hover {
    background: rgba(219, 81, 32, 0.19);
}
.account-address-card__lines {
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin: 14px 0 0 47px;
    padding-top: 12px;
    color: #e3e5eb;
    border-top: 1px solid rgba(255, 255, 255, 0.09);
    font-size: 11px;
    line-height: 1.5;
    overflow-wrap: anywhere;
}
.account-address-card__lines span:last-child {
    color: #aeb5c3;
}
.account-address-card__empty {
    margin: 13px 0 0 47px;
    padding-top: 12px;
    color: #aeb5c3;
    border-top: 1px solid rgba(255, 255, 255, 0.09);
    font-size: 11px;
    line-height: 1.6;
}
.theme--light.account-address-card .account-address-card__eyebrow {
    color: #ba431b;
}
.theme--light.account-address-card .account-address-card__lines {
    color: #343741;
    border-top-color: rgba(56, 62, 74, 0.12);
}
.theme--light.account-address-card .account-address-card__lines span:last-child,
.theme--light.account-address-card .account-address-card__empty {
    color: #6a6e79;
}
@media (max-width: 480px) {
    .account-address-card__lines,
    .account-address-card__empty {
        margin-left: 0;
    }
}
</style>
